import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-salesforce',
  templateUrl: './salesforce.component.html',
  styleUrls: ['./salesforce.component.scss']
})
export class SalesforceComponent implements OnInit {
  displayDevNConsultTab:boolean=false;
  displayServicesTab:boolean=false;
  displayIntegrationTab:boolean=false;
  displaySupportTab:boolean=false;
  displayUITab:boolean=false;
  id: any;
  title = 'ITARIUM Technologies India Pvt. Ltd. | Services';
  
  constructor(private titleService: Title,private activatedRoute: ActivatedRoute, private meta:Meta) { }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.meta.addTags([
      {name: 'keywords', content: 'BMC, BMC Softwares, BMC Tools, Itarium Technologies, IT Service Management, Managed Service, IT Strategy & Consulting, Staff Augmentation' },
      {name: 'description', content: 'We strive for innovation that can enable companies deliver technology driven transformations and tailored experiences suited to our customer expectations.'},
      {name: 'robots', content: 'index, follow'}
    ]);
    window.scrollTo(0, 0)
    this.activatedRoute.paramMap.subscribe((params:Params) => {
      this.id = params.get("id")
      console.log("ID", this.id)
      this.displayDevNConsultTab=false;
      this.displayServicesTab=false;
      this.displayIntegrationTab=false;
      this.displaySupportTab=false;
      this.displayUITab=false;

      if(this.id==="DevNConsult")
      {
      this.displayDevNConsultTab=true;
      }
      else if(this.id==="Services")
      {
      this.displayServicesTab=true;
      }
      else if(this.id==="Integration")
      {
      this.displayIntegrationTab=true;
      }
      else if(this.id==="Support")
      {
      this.displaySupportTab=true;
      }
      else if(this.id==="UI")
      {
      this.displayUITab=true;
      }
    })
  }

  scroll(){
    // window.scrollTo(380,380)
  }

}
